import React, { useEffect } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { Alert } from "components/bootstrap";
import { Col } from "common/components";
import RuleOptionsFormFields from "security-app/components/SigmaRules/SigmaEventDefinitions/RuleOptionsFormFields";
import CopyOptionsToAllButton from "security-app/components/SigmaRules/SigmaEventDefinitions/CopyOptionsToAllButton";
import { PATH_ACTIONS } from "./utils";
const StyledHr = styled.hr`
  border: none;
  margin: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.input.border};
  margin-top: ${({ theme }) => theme.spacings.sm};
  border-color: ${({ theme }) => theme.colors.button.primary.background};
  width: 20px;
  border-width: 2px;
`;
function RuleFormWithTitle({ ruleId, ruleTitle, pathAction }) {
  const { setFieldValue } = useFormikContext();
  const overridesKey = pathAction === PATH_ACTIONS.gitImport ? "rule_overrides" : "file_overrides";
  useEffect(() => {
    if (ruleId) setFieldValue("id", ruleId, false);
  }, [ruleId, setFieldValue]);
  return ruleId ? /* @__PURE__ */ React.createElement(Col, { $gap: "md" }, /* @__PURE__ */ React.createElement("h2", null, /* @__PURE__ */ React.createElement("strong", null, ruleTitle), /* @__PURE__ */ React.createElement(StyledHr, null)), /* @__PURE__ */ React.createElement(RuleOptionsFormFields, { fieldNamePrefix: `${overridesKey}.${ruleId}` }), /* @__PURE__ */ React.createElement(CopyOptionsToAllButton, { ruleId, pathAction })) : /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", style: { width: "100%" }, title: "No rule selected" }, "Select a rule to view and edit its options.");
}
export default RuleFormWithTitle;
